import { parseString } from 'dynamic-typing';
const utf8Decoder = new TextDecoder();
export const decoder = {
    decode: (array) => {
        return utf8Decoder.decode(array);
    },
};
export const defaultOptions = {
    trimValues: true,
    attributesNodeName: '',
    ignoreAttributes: false,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    parseAttributesString: true,
    textNodeName: '#text',
    arrayMode: false,
    cdataTagName: false,
    tagNameProcessor: (name) => name,
    attributeNameProcessor: (name) => `$${name}`,
    tagValueProcessor: (value) => {
        const string = decoder.decode(value).replaceAll('\r', '');
        return parseString(string);
    },
    attributeValueProcessor: (value) => parseString(value),
    stopNodes: [],
};
export const defaultStreamOptions = {
    ...defaultOptions,
    maxEntrySize: 1e7,
    maxBufferSize: 2e8,
};
//# sourceMappingURL=defaultOptions.js.map